module.exports = __webpack_public_path__ + "static/media/jen_l.537d203d.jpg";